import React, { useEffect, useState } from 'react';
import { Cascader  } from 'antd';
import { useBizCategoryTree } from 'hooks';

export interface BizCategoryProp {
  defaultValue?: number;
  disable?: boolean;
  onChangeSelect?: (value: string) => void;
}

const BizCategory = ({
  defaultValue,
  disable = false,
  onChangeSelect
}: BizCategoryProp): React.ReactElement => {
  const [selectValue, setSelectValue] = useState<string[]>([]);

  const findValue = (val: number, tree: any[]) => {
    let find = false;
    for (const item of tree) {
      for (const biz of item.children) {
        if (biz.value.toString() === val.toString()) {
          setSelectValue([biz.group_label.toString(), biz.label.toString()]);
          find = true;
          break;
        }
      }
      if (find) break;
    }
  };

  /* ======================================================
  * hooks
  * ====================================================== */
  const { bizCateTree } = useBizCategoryTree();  

  /* ======================================================
   * effects
   * ====================================================== */
  useEffect(() => {
    if (bizCateTree && defaultValue) {
      setSelectValue([]);
      findValue(defaultValue, bizCateTree);
    } else {
      setSelectValue([]); 
    }
  }, [bizCateTree, defaultValue]);

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <Cascader  
      style={{width:'200px'}} 
      placeholder={'업종'}
      options={bizCateTree}
      showSearch={true}
      onChange={(value) => {
        if (value) {
          const biz = value as string[];
          setSelectValue(biz);
          onChangeSelect?.(biz[1]);
        } else {
          setSelectValue([]);  
          onChangeSelect?.('');
        }
      }}      
      value={selectValue}
      disabled={disable}
    /> 
  );
};

export default BizCategory;
